<template>
    <Container>
         <div class=""
        :class="[
            'flex',
             alignment,
             desktopWidth,
             mobileWidth
             ]"
    >
<!--                         buttonColor ? `background-color:${buttonColor}` : '',-->

         <button
             class="hover:brightness-150 transition-all duration-300 inline-flex items-center justify-center text-center whitespace-nowrap"
             @click="navigateTo"
             :class="[
             desktopWidth,
             mobileWidth
             ]"
             :style="[
                 outlineButton
        ? `background-color: white; color: ${buttonColor}; border: 2px solid ${buttonColor}`
        : `background-color: ${buttonColor}; color: ${textButtonColor}; border: 2px solid ${buttonColor}`,

                    `padding-top:${isMobile?mobileTopPadding:topPadding}px`,
                    `padding-bottom:${isMobile?mobileBottomPadding:bottomPadding}px`,
                    `padding-right:${rightPadding}px`,
                    `padding-left:${leftPadding}px`,
                    `font-size:${isMobile?mobileTextSize:textSize}px`,
                    `font-weight:${textWeight}`,
                    `color:${textButtonColor}`,
                    `border-radius: ${buttonRadius}px`,
                    `margin-top:${verticalMargin}px`,
                    `margin-bottom:${verticalMargin}px`,
                    `margin-right:${horizontalMargin}px`,
                    `margin-left:${horizontalMargin}px`,
             ]"
         >
             {{content}}
          </button>
    </div>
    </Container>

</template>
<script>
import Container from '../../../Layouts/Container.vue'

export default {
    components: {
        Container,
    },
    data() {
        return {
            isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : (this.$page?.props?.isMobileUA ?? false)
        };
    },
    props: {
        content: {
            type: String,
            default: 'Button'
        },
         buttonColor: {
            type: String,
            default: '#008037'
         },
        hoverButtonColor: {
            type: String,
            default: '#002037'
        },
        textButtonColor: {
            type:String,
            default:'#ffffff'
        },
        buttonLink: {
            type: String,
            default:null
        },
        openNewTab: {
            type: Boolean,
            default:false
        },
        textSize: {
            type: Number,
            default:20
        },
        mobileTextSize: {
            type: Number,
            default:20
        },
        textWeight: {
            type:Number,
            default: 50
        },
        topPadding: {
            type:Number,
            default:10
        },
        bottomPadding: {
            type:Number,
            default:10
        },
        mobileTopPadding: {
            type: Number,
            default: 7
        },
        mobileBottomPadding: {
            type: Number,
            default: 7
        },
        buttonRadius: {
            type:Number,
            default:5
        },
        rightPadding: {
            type:Number,
            default:10
        },
        leftPadding: {
            type:Number,
            default:10
        },
        alignment: {
            type:String,
            default:'justify-start'
        },
        desktopWidth: {
            type:String,
            default:'md:w-auto'
        },
        mobileWidth: {
            type:String,
            default:'w-auto'
        },
        outlineButton:{
            type:Boolean,
            default:false
        },
        verticalMargin: {
            type: Number,
            default: 16
        },
        horizontalMargin: {
            type: Number,
            default: 16
        },
    },
    methods:{
        navigateTo () {
            if (this.buttonLink) {
                window.open(this.buttonLink, this.openNewTab?"_blank":"_self");
            }
        },
        updateIsMobile() {
            this.isMobile = window.innerWidth < 768;
        }
    },
     mounted() {
        // Set up the resize event listener
        window.addEventListener("resize", this.updateIsMobile);
    },
    beforeUnmount() {
        // Clean up the listener to prevent memory leaks
        window.removeEventListener("resize", this.updateIsMobile);
    },
};
</script>

